import React from 'react';
import GameCardItem from '../../components/CardItem/GameCardItem';
import { OnePieceCard } from '../../types/onepiece';

interface OnePieceCardItemProps {
  card: OnePieceCard;
  isOwned: boolean;
  isFavorite: boolean;
  isWishlist: boolean;
  onCardClick: (card: OnePieceCard) => void;
  onToggleOwnership: (cardId: string) => void;
  onToggleWishlist: (cardId: string) => void;
  onToggleFavorite: (cardId: string) => void;
  isToggling: boolean;
}

const OnePieceCardItem: React.FC<OnePieceCardItemProps> = (props) => {
  return <GameCardItem {...props} />;
};

export default OnePieceCardItem;
